import { render, staticRenderFns } from "./ProductCart.vue?vue&type=template&id=f39b9f5a&scoped=true"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"
import style0 from "./ProductCart.vue?vue&type=style&index=0&id=f39b9f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b9f5a",
  null
  
)

export default component.exports